/*!
 * Copyright (c) Microsoft. All rights reserved.
 * Licensed under the MIT license. See LICENSE file in the project.
 */
import styled from 'styled-components'

export const GraphFilteringContainer = styled.div`
	padding-top: 10px;
`
